import SeoHead from '@/components/base/SeoHead';
import { getSiteUrl } from '@/utils/siteUrl';
import HeroSection from './components/HeroSection';
import SeoIntroSection from './components/SeoIntroSection';
import FeatureGridSection from './components/FeatureGridSection';
import CategoryButtonsSection from './components/CategoryButtonsSection';
import GuideCardsSection from './components/GuideCardsSection';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import ArticlesSection from './components/ArticlesSection';
import CtaSection from './components/CtaSection';

const siteUrl = getSiteUrl();

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: 'MulebuySpreadsheets',
      description: 'Your trusted hub for verified mulebuy spreadsheet resources, agent comparisons, and sourcing guides.',
      inLanguage: 'en',
      publisher: {
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'MulebuySpreadsheets',
        url: `${siteUrl}/`,
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Best Mulebuy Spreadsheet Guide 2026 — Verified Lists & Tools | MulebuySpreadsheets',
      description: 'Discover the most updated mulebuy spreadsheet collections, comparison tools, and verified agent data. Find reliable mulebuy spreadsheet lists, agent comparisons, and sourcing guides all in one place.',
      inLanguage: 'en',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@type': 'Thing', name: 'mulebuy spreadsheet' },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: `${siteUrl}/`,
          },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SeoHead jsonLd={homeJsonLd} />
      <main>
        <HeroSection />
        <SeoIntroSection />
        <FeatureGridSection />
        <CategoryButtonsSection />
        <GuideCardsSection />
        <TrustSection />
        <TestimonialSection />
        <ArticlesSection />
        <CtaSection />
      </main>
    </>
  );
}